function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 3;\n  transition: flex 250ms linear;\n  margin: ",
        ";\n  align-self: flex-start;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: left;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 800;\n  padding-left: 5px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: left;\n  padding-bottom: 5px;\n  opacity: 0.7;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 20px;\n  text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import React, { Component } from "react";
import propTypes from "prop-types";
import styled from "styled-components";
import { Form, Formik } from "formik";
import { object, string, date } from "yup";
import { withContext } from "../../../wr-context";
import Card from "../../../card";
import { FormikInput } from "../../../input";
import { FormikButton } from "../../../button";
import { FormikDatepicker } from "../../../datepicker";
import { Row, SpacedCol, Col } from "../../../grid";
import GenerateProposalDropdown from "../../../generate-proposal-dropdown";
import Progress from "../../../progress";
import { utils } from "../../../../modules/product";
import i18n from "../../../../utils/i18n";
import formatCurrency from "../../../../utils/format-currency";
import { tryCallRenderProp } from "../../../../utils/try-call";
import CartProduct from "./cart-product";
var ProductsCart = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.components.productDetails.cart.margin;
}, function(param) {
    var theme = param.theme;
    return theme.components.productDetails.cart.sticky && "\n    position: sticky;\n    top: 0;\n  ";
});
var CartHeader = styled.div(_templateObject1());
var CartBody = styled.div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.components.productDetails.cart.maxHeight && "\n    max-height: ".concat(theme.components.productDetails.cart.maxHeight, ";\n    overflow-y: auto;\n  ");
});
var CartTotal = styled.span(_templateObject3());
var StyledH3 = styled.h3(_templateObject4());
var ModalDescription = styled.p(_templateObject5());
var validationSchema = object({
    company: string().required("Company is a required field"),
    name: string().required("Name is a required field"),
    email: string().email().required("Email is a required field"),
    desiredStartDate: date()
});
var Cart = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Cart, Component);
    var _super = _createSuper(Cart);
    function Cart(props) {
        _classCallCheck(this, Cart);
        var _this;
        _this = _super.call(this, props);
        _this.asDraft = false;
        _this.asQuotePdf = false;
        _this.asQuoteWord = false;
        _this.modalProps = {
            showClose: false,
            body: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ModalDescription, null, "We are generating your proposal"), /*#__PURE__*/ React.createElement(Progress, null))
        };
        _this.handleSubmit = function(values, formikActions) {
            if (_this.props.handleSubmit) {
                _this.props.handleSubmit(values, formikActions);
                return;
            }
            if (_this.asDraft) {
                _this.props.submitProposal({
                    asDraft: _this.asDraft,
                    formValues: values
                });
                _this.props.context.actions.openModal(_objectSpread({}, _this.modalProps));
            }
            if (_this.asQuotePdf) {
                _this.props.submitProposal({
                    asQuotePdf: _this.asQuotePdf,
                    formValues: values
                });
                _this.props.context.actions.openModal(_objectSpread({}, _this.modalProps));
            }
            if (_this.asQuoteWord) {
                _this.props.submitProposal({
                    asQuoteWord: _this.asQuoteWord,
                    formValues: values
                });
                _this.props.context.actions.openModal(_objectSpread({}, _this.modalProps));
            }
            formikActions.setSubmitting(false);
        };
        _this.setSubmitType = function(submitType) {
            _this.asDraft = false;
            _this.asQuotePdf = false;
            _this.asQuoteWord = false;
            if (submitType === "asDraft") {
                _this.asDraft = true;
            }
            if (submitType === "asQuotePdf") {
                _this.asQuotePdf = true;
            }
            if (submitType === "asQuoteWord") {
                _this.asQuoteWord = true;
            }
        };
        _this.getTotalPrice = function() {
            var cart = _this.props.context.state.cart;
            var totalPrice = 0;
            var withoutDividing = true;
            cart.map(function(product) {
                totalPrice += utils.getPrice(product, withoutDividing);
            });
            return totalPrice;
        };
        _this.getPointTotalPrice = function() {
            var cart = _this.props.context.state.cart;
            var totalPrice = 0;
            var withoutDividing = true;
            var credits = true;
            cart.map(function(product) {
                totalPrice += parseInt(utils.getPrice(product, withoutDividing, credits));
            });
            return totalPrice;
        };
        return _this;
    }
    var _proto = Cart.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, context = _props.context, asPdf = _props.asPdf, asDoc = _props.asDoc, initialValues = _props.initialValues, validationSchema = _props.validationSchema, showVMSButton = _props.showVMSButton, hidePriceAndDurationIfZero = _props.hidePriceAndDurationIfZero, renderPrice = _props.renderPrice, renderForm = _props.renderForm, renderName = _props.renderName, renderCartProducts = _props.renderCartProducts, renderProductSummary = _props.renderProductSummary;
        var _state = context.state, cart = _state.cart, isLoggedIn = _state.isLoggedIn, pointSystem = _state.pointSystem;
        var priceValue = this.getTotalPrice();
        var price = pointSystem ? this.getPointTotalPrice() : formatCurrency(this.getTotalPrice());
        var cardChildren = function(param) {
            var Header = param.Header, Body = param.Body;
            var _this1 = _this;
            /*#__PURE__*/ return React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Header, {
                divider: true
            }, /*#__PURE__*/ React.createElement(CartHeader, null, /*#__PURE__*/ React.createElement(Formik, {
                onSubmit: _this.handleSubmit,
                initialValues: initialValues,
                validationSchema: validationSchema
            }, tryCallRenderProp(renderForm, {
                props: _objectSpread({}, _this.props),
                shouldDefaultRender: function() {
                    return true;
                },
                defaultRender: function() {
                    var _this = _this1;
                    var ref, ref1;
                    /*#__PURE__*/ return React.createElement(Form, {
                        noValidate: true
                    }, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                        xs: 12
                    }, /*#__PURE__*/ React.createElement("span", null, pointSystem ? i18n("proposalGeneration.form.totalPriceInPoints") : i18n("proposalGeneration.form.totalPrice"), ":"), /*#__PURE__*/ React.createElement(CartTotal, null, price)), /*#__PURE__*/ React.createElement(SpacedCol, {
                        xs: 12
                    }, /*#__PURE__*/ React.createElement(StyledH3, null, i18n("proposalGeneration.form.desiredStartDate")), /*#__PURE__*/ React.createElement(FormikDatepicker, {
                        fullWidth: true,
                        large: true,
                        name: "desiredStartDate"
                    })), /*#__PURE__*/ React.createElement(SpacedCol, {
                        xs: 12
                    }, /*#__PURE__*/ React.createElement(FormikInput, {
                        name: "company",
                        type: "text",
                        placeholder: i18n("proposalGeneration.form.company"),
                        fullWidth: true
                    })), /*#__PURE__*/ React.createElement(SpacedCol, {
                        xs: 12
                    }, /*#__PURE__*/ React.createElement(FormikInput, {
                        name: "name",
                        type: "text",
                        placeholder: i18n("proposalGeneration.form.name"),
                        fullWidth: true
                    })), /*#__PURE__*/ React.createElement(SpacedCol, {
                        xs: 12
                    }, /*#__PURE__*/ React.createElement(FormikInput, {
                        name: "email",
                        type: "email",
                        placeholder: i18n("proposalGeneration.form.email"),
                        fullWidth: true
                    })), /*#__PURE__*/ React.createElement(SpacedCol, {
                        xs: 12
                    }, /*#__PURE__*/ React.createElement(GenerateProposalDropdown, {
                        theme: (ref = _this1.props.context.theme.components) === null || ref === void 0 ? void 0 : (ref1 = ref.dropdown) === null || ref1 === void 0 ? void 0 : ref1.color,
                        options: {
                            asPdf: asPdf,
                            asDoc: asDoc,
                            asDraft: true
                        },
                        isLoggedIn: isLoggedIn,
                        onChange: function(val) {
                            return _this.setSubmitType(val);
                        }
                    })), showVMSButton && /*#__PURE__*/ React.createElement(SpacedCol, {
                        xs: 12
                    }, /*#__PURE__*/ React.createElement(FormikButton, {
                        fullWidth: true,
                        primary: true,
                        type: "button",
                        disabled: true
                    }, i18n("proposalGeneration.sendToVms")))));
                }
            })))), Boolean(cart.length) && /*#__PURE__*/ React.createElement(CartBody, {
                className: "cart-body"
            }, tryCallRenderProp(renderCartProducts, {
                props: _objectSpread({}, _this.props),
                shouldDefaultRender: function() {
                    return true;
                },
                defaultRender: function() {
                    return /*#__PURE__*/ React.createElement(Body, null, cart.map(function(product) {
                        var withoutDividing = true;
                        var price = utils.getPrice(product, withoutDividing);
                        return /*#__PURE__*/ React.createElement(CartProduct, {
                            priceValue: priceValue,
                            hidePriceAndDurationIfZero: hidePriceAndDurationIfZero,
                            key: product.id + (product.cartId || ""),
                            product: product,
                            price: price,
                            renderPrice: renderPrice,
                            renderName: renderName,
                            renderProductSummary: renderProductSummary
                        });
                    }));
                }
            })));
        };
        return /*#__PURE__*/ React.createElement(ProductsCart, {
            className: "product-details-cart"
        }, /*#__PURE__*/ React.createElement(Card, null, cardChildren));
    };
    return Cart;
}(Component);
Cart.propTypes = {
    initialValues: propTypes.object,
    renderForm: propTypes.func,
    renderPrice: propTypes.func,
    renderName: propTypes.func,
    validationSchema: propTypes.object,
    handleSubmit: propTypes.func,
    renderCartProducts: propTypes.func,
    renderProductSummary: propTypes.func
};
Cart.defaultProps = {
    initialValues: {
        company: "",
        name: "",
        email: "",
        desiredStartDate: ""
    },
    validationSchema: validationSchema,
    renderPrice: function(v) {
        return v.defaultRender();
    },
    renderName: function(v) {
        return v.defaultRender();
    },
    renderForm: undefined,
    handleSubmit: undefined,
    renderCartProducts: undefined,
    renderProductSummary: undefined
};
export default withContext(Cart);
